export enum ChangeTradePhaseTypeEnum {
  approve,
  reject,
  return
}



// WEBPACK FOOTER //
// ./src/components/Refatoracao/RejectApproveTrade/ChangeTradePhaseTypeEnum.ts